import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const rewardsSignupRoute: RouteConfig<'with-page'> = {
    name: 'Sign Up',
    page: lazy(() => import('.')),
    path: '/rewards/signups',
    flags: ['member-route'],
    permissions: ['rewards'],
    context:'member'
}